import { getStore } from '../store/store';

export function isFolderSelectorOpen(): boolean {
    return getStore().isOpen;
}
